import { NodeBaseDto, BalanceInformationNodeDto } from '../types';
import { SourceModelBase } from '../../custom_shared/models';
import {
    GeneralInformationNodeModel,
    BalanceInformationNodeModel,
    EntryCodeNodeModel,
    WorksheetModel,
    NodeBaseModel
} from '../models';

export default class NodeFactory {
    static createNode(
        data: NodeBaseDto,
        sources: SourceModelBase[],
        worksheet: WorksheetModel,
        parentNode?: NodeBaseModel
    ) {
        switch (data.type) {
            case 'GeneralInformationNode':
                return new GeneralInformationNodeModel(data, sources, worksheet, parentNode);
            case 'BalanceInformationNode':
                return new BalanceInformationNodeModel(
                    data as BalanceInformationNodeDto,
                    sources,
                    worksheet,
                    parentNode
                );
            case 'EntryCodeNode':
                return new EntryCodeNodeModel(data, sources, worksheet, parentNode);
            default:
                throw new Error('Unsupported node type');
        }
    }
}
